import { Component, inject } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { CustomValidators } from '@argo/validation';
import { ScaModuleTitleComponent, ScaCardWorkshopComponent, ScaAlertComponent, ScaBadgeComponent, ScaIconComponent, ScaButtonComponent, ScaTextFieldModule } from '@argo-dev-components-sca-angular/dev-components-sca';

@Component({
  selector: 'app-valid-forms-test',
  standalone: true,
  imports: [
    CommonModule,
       FormsModule,
    ReactiveFormsModule,
    JsonPipe,
    ScaModuleTitleComponent,
    ScaCardWorkshopComponent,
    ScaAlertComponent,
    ScaBadgeComponent,
    ScaIconComponent,
    ScaButtonComponent,
    ScaTextFieldModule
  ],
  providers: [CustomValidators],
  templateUrl: './valid-forms-test.component.html',
  styleUrl: './valid-forms-test.component.scss'
})
export class ValidFormsTestComponent {
  form: FormGroup;
  private fb = inject(FormBuilder);
  private customValidators = inject(CustomValidators) as CustomValidators;

  constructor() {
    this.form = this.fb.group({
      email: ['', [Validators.required, this.customValidators.validateEmail()]],
      dni: ['', [Validators.required, this.customValidators.validateDocument('DNI')]],
      fechaNacimiento: ['', [Validators.required, this.customValidators.validateDate('DD/MM/YYYY')]],
      telefono: ['', [Validators.required, this.customValidators.validatePhone('movil')]]
    });
  }

  submit() {
    if (this.form.valid) {
      alert('Formulario válido!');
    } else {
      alert('Formulario inválido.');
    }
  }
}
